export function PageSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-6 animate-pulse">
      {/* Header skeleton */}
      <div className="h-8 w-48 bg-muted rounded" />

      {/* Content skeleton */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-32 bg-muted rounded-lg" />
        ))}
      </div>

      {/* Table/chart skeleton */}
      <div className="h-96 bg-muted rounded-lg mt-4" />
    </div>
  );
}
